/**
 * Mock 模块：heart_voyage_unbind
 * @see mockMd/heart_voyage_unbind.md
 */
import type {UnbindData} from '../types'

/** @see mockMd/heart_voyage_unbind.md */
export const HeartVoyageUnbindMock: UnbindData = {
  err_msg: '',
}
